import { createSlice } from '@reduxjs/toolkit'

export const referrerSlice = createSlice({
  name: 'referrer',
  initialState: '',
  reducers: {
    updateReferrer: (state, action) => {
      return action.payload;
    },
  },
})

export const { updateReferrer } = referrerSlice.actions;

export default referrerSlice.reducer;
